module.exports = __webpack_public_path__ + "static/img/active5.0c96271d.png";